import classNames from 'classnames'
import { ReactNode } from 'react'
import { FieldErrors } from 'react-hook-form'
import { FieldWarnings } from './Forms/FieldWarnings'

interface IField {
  name: string
  label?: ReactNode
  optional?: boolean
  className?: string
  errorClassName?: string
  warningClassName?: string
  children: ReactNode
  errors?: FieldErrors
  warnings?: FieldWarnings
}

const Field = ({
  name,
  optional,
  label,
  className = '',
  errorClassName,
  warningClassName,
  children,
  errors,
  warnings
}: IField) => {
  return (
    <div className={className}>
      {label && (
        <label htmlFor={name} className="h7 mb-1 inline-block align-top">
          {label}
          {optional && <span className="text-gray-300">&nbsp;(Optional)</span>}
        </label>
      )}
      {children}
      {errors?.[name] && (
        <FieldMessage
          className={errorClassName}
          message={errors?.[name]?.message?.toString()}
          theme="error"
        />
      )}
      {warnings?.[name] &&
        !errors?.[name] && ( // if there are errors then don't display the warnings
          <FieldMessage
            className={warningClassName}
            message={warnings?.[name].message?.toString()}
            theme="warning"
          />
        )}
    </div>
  )
}

export default Field

type FieldMessageProps = {
  className?: string
  message: string
  theme: 'error' | 'warning'
}
const FieldMessage = ({ className, message, theme }: FieldMessageProps) => {
  const baseClasses = 'mt-1 body-sm'
  const themeClasses = theme === 'error' ? 'text-error' : 'text-alert'

  return (
    <p className={classNames(baseClasses, themeClasses, className)}>
      {message}
    </p>
  )
}
